module.exports = __webpack_public_path__ + "img/send.5510c661.gif";